/* OROS Design — Configurator JS */
(function () {
  'use strict';

  var sizeBtns = document.querySelectorAll('.config-size-btn');
  var finishBtns = document.querySelectorAll('.config-finish-btn');
  var kitBtns = document.querySelectorAll('.config-kit-btn');
  var luneBtns = document.querySelectorAll('.config-lune-btn');
  var summaryLabel = document.getElementById('config-summary-label');
  var previewImg = document.getElementById('config-preview-img');
  var previewTitle = document.getElementById('config-preview-title');
  var previewMeta = document.getElementById('config-preview-meta');
  var totalEls = document.querySelectorAll('.config-total-value');
  var luneLine = document.getElementById('config-lune-line');
  var luneLabel = document.getElementById('config-lune-label');
  var luneImg = document.getElementById('config-lune-img');
  var discountLine = document.getElementById('config-discount-line');
  var addCartBtns = document.querySelectorAll('.config-add-cart-btn');
  var mobileSummary = document.getElementById('config-mobile-summary');
  var mobileLune = document.getElementById('config-mobile-lune');
  var mobileBar = document.getElementById('config-mobile-bar');

  var state = {
    size: 'classic',
    finish: 'noir',
    kit: 'prestige',
    lune: 'none',
    lunePrice: 0
  };

  var sizeNames = {
    classic: 'Peak 600',
    luxe: 'Peak 800'
  };

  var finishNames = {
    gris: 'Béton naturel',
    noir: 'Finition noire'
  };

  var finishShortNames = {
    gris: 'Béton',
    noir: 'Noir'
  };

  var kitNames = {
    classic: 'Classic',
    prestige: 'Prestige',
    signature: 'Signature'
  };

  var kitMeta = {
    classic: 'Livraison incluse',
    prestige: 'Pare-étincelles inclus · Installation sur roche',
    signature: 'Pare-étincelles inclus · Pavé ou béton'
  };

  var luneNames = {
    gris: 'Béton naturel',
    noir: 'Finition noire'
  };

  var configData = window.orosConfig || {};
  var kitPrices = configData.prices || {
    gris: {
      classic: { classic: 2999, luxe: 3749 },
      prestige: { classic: 3499, luxe: 4374 },
      signature: { classic: 3999, luxe: 4999 }
    },
    noir: {
      classic: { classic: 3799, luxe: 4749 },
      prestige: { classic: 4299, luxe: 5374 },
      signature: { classic: 4799, luxe: 5999 }
    }
  };
  var duoDiscount = 199;

  function formatPrice(n) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + ' $';
  }

  function setSelected(buttons, selectedBtn) {
    buttons.forEach(function (btn) {
      btn.classList.remove('border-primary', 'bg-primary/5', 'text-primary');
      btn.classList.add('border-white/10');
      btn.setAttribute('aria-pressed', 'false');
      var check = btn.querySelector('.config-check');
      if (check) {
        check.classList.add('hidden');
        check.classList.remove('flex');
      }
    });

    selectedBtn.classList.remove('border-white/10');
    selectedBtn.classList.add('border-primary', 'bg-primary/5');
    selectedBtn.setAttribute('aria-pressed', 'true');
    var selectedCheck = selectedBtn.querySelector('.config-check');
    if (selectedCheck) {
      selectedCheck.classList.remove('hidden');
      selectedCheck.classList.add('flex');
    }
  }

  function setCompactSelected(buttons, selectedBtn) {
    buttons.forEach(function (btn) {
      btn.classList.remove('border-primary', 'bg-primary/5', 'text-primary');
      btn.classList.add('border-white/10', 'text-gray-300');
      btn.setAttribute('aria-pressed', 'false');
    });

    selectedBtn.classList.remove('border-white/10', 'text-gray-300');
    selectedBtn.classList.add('border-primary', 'bg-primary/5', 'text-primary');
    selectedBtn.setAttribute('aria-pressed', 'true');
  }

  function currentBasePrice() {
    var pricesForFinish = kitPrices[state.finish] || kitPrices.noir;
    var pricesForKit = pricesForFinish[state.kit] || pricesForFinish.prestige;
    return pricesForKit[state.size] || pricesForKit.classic;
  }

  function currentDuoDiscount() {
    if (state.lune === 'noir' && state.finish === 'noir' && state.size === 'luxe') {
      return 399;
    }

    return duoDiscount;
  }

  function updateKitPrices() {
    var pricesForFinish = kitPrices[state.finish] || kitPrices.noir;
    Object.keys(pricesForFinish).forEach(function (kit) {
      var el = document.querySelector('[data-kit-price="' + kit + '"]');
      if (el) el.textContent = formatPrice(pricesForFinish[kit][state.size]);
    });
  }

  function updateUI() {
    var discount = state.lune !== 'none' && state.lunePrice > 0 ? currentDuoDiscount() : 0;
    var total = currentBasePrice() + state.lunePrice - discount;
    var summaryText = [
      sizeNames[state.size],
      kitNames[state.kit],
      finishNames[state.finish]
    ].join(' · ');
    var mobileSummaryText = [
      sizeNames[state.size],
      kitNames[state.kit],
      finishShortNames[state.finish] || finishNames[state.finish]
    ].join(' · ');

    updateKitPrices();

    if (summaryLabel) {
      summaryLabel.textContent = summaryText;
    }

    if (mobileSummary) {
      mobileSummary.textContent = mobileSummaryText;
    }

    if (mobileLune) {
      if (state.lune !== 'none' && state.lunePrice > 0) {
        mobileLune.textContent = '+ Demi-Lune · ' + (finishShortNames[state.lune] || luneNames[state.lune] || state.lune);
        mobileLune.classList.remove('hidden');
      } else {
        mobileLune.classList.add('hidden');
      }
    }

    if (previewTitle) {
      previewTitle.textContent = sizeNames[state.size] + ' · ' + kitNames[state.kit];
    }

    if (previewMeta) {
      previewMeta.textContent = finishNames[state.finish] + ' · ' + (kitMeta[state.kit] || 'Installation incluse');
    }

    if (previewImg) {
      var kitFinishSrc = previewImg.getAttribute('data-' + state.kit + '-' + state.finish);
      var finishSrc = previewImg.getAttribute('data-' + state.finish);
      var kitSrc = state.finish === 'noir' ? previewImg.getAttribute('data-' + state.kit) : null;
      var nextSrc = kitFinishSrc || kitSrc || finishSrc;
      if (nextSrc && previewImg.src !== nextSrc) {
        previewImg.style.opacity = '0';
        setTimeout(function () {
          previewImg.src = nextSrc;
          previewImg.alt = 'Kit ' + kitNames[state.kit] + ' OROS · ' + finishNames[state.finish];
          previewImg.style.opacity = '1';
        }, 120);
      }
    }

    if (luneLine && luneLabel) {
      if (state.lune !== 'none' && state.lunePrice > 0) {
        luneLine.classList.remove('hidden');
        luneLabel.textContent = luneNames[state.lune] || state.lune;
      } else {
        luneLine.classList.add('hidden');
      }
    }

    if (luneImg) {
      var luneImgKey = state.lune === 'none' ? state.finish : state.lune;
      var nextLuneSrc = luneImg.getAttribute('data-' + luneImgKey);
      if (nextLuneSrc && luneImg.src !== nextLuneSrc) {
        luneImg.style.opacity = '0';
        setTimeout(function () {
          luneImg.src = nextLuneSrc;
          luneImg.alt = 'Demi-Lune OROS · ' + (luneNames[luneImgKey] || finishNames[luneImgKey] || 'Finition noire');
          luneImg.style.opacity = '1';
        }, 100);
      }
    }

    if (discountLine) {
      if (discount > 0) {
        discountLine.classList.remove('hidden');
      } else {
        discountLine.classList.add('hidden');
      }
    }

    totalEls.forEach(function (el) {
      el.textContent = formatPrice(total);
    });
  }

  sizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setSelected(sizeBtns, btn);
      state.size = btn.dataset.size || 'classic';
      updateUI();
    });
  });

  finishBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setSelected(finishBtns, btn);
      state.finish = btn.dataset.finish || 'noir';
      updateUI();
    });
  });

  kitBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setSelected(kitBtns, btn);
      state.kit = btn.dataset.kit || 'prestige';
      updateUI();
    });
  });

  luneBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setCompactSelected(luneBtns, btn);
      state.lune = btn.dataset.lune || 'none';
      state.lunePrice = parseInt(btn.dataset.lunePrice, 10) || 0;
      updateUI();
    });
  });

  function setCartButtonsLoading(isLoading) {
    addCartBtns.forEach(function (btn) {
      btn.disabled = isLoading;
      btn.textContent = isLoading ? 'Ajout...' : (btn.id === 'config-add-cart' ? 'Commandez mon foyer' : 'Commander');
    });
  }

  function addConfigurationToCart() {
      var variants = configData.variants || window.orosVariants || { foyer: {}, lune: {} };
      var foyerVariant = variants.foyer &&
        variants.foyer[state.size] &&
        variants.foyer[state.size][state.finish] &&
        variants.foyer[state.size][state.finish][state.kit];
      var luneVariant = state.lune !== 'none' ? variants.lune[state.lune] : null;

      if (!foyerVariant) {
        alert('Produit non disponible. Contactez samuel@orosdesign.ca');
        return;
      }

      var items = [{
        id: foyerVariant,
        quantity: 1,
        properties: {
          'Taille': sizeNames[state.size],
          'Kit': kitNames[state.kit],
          'Finition': finishNames[state.finish],
          'Total estimé configurateur': formatPrice(currentBasePrice() + state.lunePrice - (state.lune !== 'none' && state.lunePrice > 0 ? currentDuoDiscount() : 0))
        }
      }];

      if (luneVariant) {
        items.push({
          id: luneVariant,
          quantity: 1,
          properties: {
            'Finition': luneNames[state.lune],
            'Rabais duo affiché': 'Appliqué'
          }
        });
      }

      setCartButtonsLoading(true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error');
        return res.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        setCartButtonsLoading(false);
        alert('Une erreur est survenue. Réessayez ou contactez samuel@orosdesign.ca');
      });
  }

  if (addCartBtns.length) {
    addCartBtns.forEach(function (btn) {
      btn.addEventListener('click', addConfigurationToCart);
    });
  }

  function setMobileBarVisible(isVisible) {
    if (!mobileBar) return;
    mobileBar.classList.toggle('translate-y-full', !isVisible);
    mobileBar.classList.toggle('opacity-0', !isVisible);
    mobileBar.classList.toggle('pointer-events-none', !isVisible);
  }

  function updateMobileBarOffset() {
    if (!mobileBar) return;
    var cookieBanner = document.getElementById('cookie-banner');
    var cookieOffset = cookieBanner && !cookieBanner.classList.contains('hidden') ? cookieBanner.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--oros-config-bar-bottom', cookieOffset + 'px');
  }

  function shouldShowMobileBar(primaryAddCartBtn) {
    if (!mobileBar || window.innerWidth >= 1024) return false;
    var section = document.getElementById('configurateur');
    if (!section || !primaryAddCartBtn) return false;

    var scrollY = window.scrollY || window.pageYOffset;
    var sectionTop = section.getBoundingClientRect().top + scrollY;
    var sectionBottom = section.getBoundingClientRect().bottom + scrollY;
    var buttonBottom = primaryAddCartBtn.getBoundingClientRect().bottom + scrollY;
    var showAfter = buttonBottom - window.innerHeight + 96;
    var hideAfter = sectionBottom - window.innerHeight * 0.35;

    return scrollY > showAfter && scrollY < hideAfter && scrollY > sectionTop - 120;
  }

  if (mobileBar && addCartBtns.length) {
    var primaryAddCartBtn = document.getElementById('config-add-cart');
    var mobileBarTicking = false;
    var refreshMobileBar = function () {
      updateMobileBarOffset();
      setMobileBarVisible(shouldShowMobileBar(primaryAddCartBtn));
    };

    var requestMobileBarRefresh = function () {
      if (mobileBarTicking) return;
      mobileBarTicking = true;
      window.requestAnimationFrame(function () {
        mobileBarTicking = false;
        refreshMobileBar();
      });
    };

    window.addEventListener('scroll', requestMobileBarRefresh, { passive: true });
    window.addEventListener('resize', requestMobileBarRefresh);
    document.addEventListener('click', function (event) {
      if (event.target && (event.target.id === 'cookie-accept' || event.target.id === 'cookie-refuse')) {
        window.setTimeout(refreshMobileBar, 50);
      }
    });
    refreshMobileBar();
  }

  updateUI();
})();
